<div class="row match-height justify-content-center">
  <div class="col-md-12">
      <div class="content-wrapper container-xxl p-0">
          <div class="content-body">
              <!-- Add your content header component here if needed -->
              <app-content-header [contentHeader]="contentHeader"></app-content-header>

              <div class="row match-height">
                  <!-- Payment Method Selection -->
                  
                  <div class="col-md-4">
                    <fieldset>
                      <legend>Payment Method</legend>
                    
                      <div class="payment-method-options">
                        <div class="form-check payment-method-option">
                          <input class="form-check-input" id="auto" name="payment-method" type="radio" [(ngModel)]="selectedMethod" value="auto" />
                          <label class="form-check-label" for="auto"><h5>Auto Funding [1.5% Charge]</h5></label>
                        </div>

                        <div class="form-check payment-method-option">
                          <input class="form-check-input" id="manual" name="payment-method" type="radio" [(ngModel)]="selectedMethod" value="manual" />
                          <label class="form-check-label" for="manual"><h5>Manual Funding</h5></label>
                        </div>
        
                        <div class="form-check payment-method-option">
                          <input class="form-check-input" id="debit" name="payment-method" type="radio" [(ngModel)]="selectedMethod" value="debit" />
                          <label class="form-check-label" for="debit"><h5>ATM/Card Funding</h5></label>
                        </div>

                        <div *ngIf="data!.virtual_accounts.length > 0 " class="form-check payment-method-option">
                         <input class="form-check-input" id="kyc" name="payment-method" type="radio" [(ngModel)]="selectedMethod" value="kyc" />
                          <label class="form-check-label" for="kyc"><h5>Verify NIN/BVN</h5></label>
                        </div>

                      </div>
                    </fieldset>
                  </div>
                  <!--/ Payment Method Selection -->

                  <!-- Display Selected Card Section -->
                  <div class="col-md-8">
                      <div *ngIf="selectedMethod === 'manual'" class="payment-card">
                          <!-- Manual Funding Card Section -->
                          <div class="card">
                              <div class="card-body">
                                  <h4 class="card-title">Manual Funding</h4>
                                  <!-- Add account details or relevant information here -->
                                  <div *ngIf="siteSettings.defaultSettings.bank_details[2]">
                                    <div class="col-md-12 p-2" style="border: 1px solid #ddd; border-radius: 10px;" [innerHTML]="decodeHtml(siteSettings.defaultSettings.bank_details[2])">
                                    </div>
                                  </div>
                              </div>
                          </div>
                          <!--/ Manual Funding Card Section -->
                      </div>

                      <div *ngIf="selectedMethod === 'debit'" class="payment-card">
                          <!-- Debit Card Funding Card Section -->
                          <div class="card">
                              <div class="card-body">
                                  <h4 class="card-title">Debit Card Funding</h4>
                                  <!-- Add relevant information for debit card funding here -->
                                  <form class="form form-vertical">
                                    <div class="row">
                                      <div class="col-12">
                                        <div class="form-group">
                                          <label for="first-name-vertical"><h6>Amount to Pay</h6></label>
                                          <input
                                            type="text"
                                            [(ngModel)]="amount"
                                            id="first-name-vertical"
                                            class="form-control"
                                            name="amount"
                                            placeholder="Enter Amount"
                                          />
                                        </div>
                                      </div>

                                      <div class="form-group col-md-12">
                                          <label class="form-label" for="method"><h6>Select Method</h6></label>
                                          <ng-select (change)="selectOnlineMethod($event)">
                                              <ng-option *ngFor="let item of paymentMethods" [value]="item">{{item.label}}</ng-option>
                                          </ng-select>
                                      </div>

                                      <div class="col-12" *ngIf="online_payment.value">
                                        <button (click)="makePayment()" *ngIf="disable === false" type="submit" rippleEffect class="btn btn-primary mr-1">Make Payment</button>
                                        <button *ngIf="disable === true" type="submit" rippleEffect class="btn btn-outline-secondary mr-1">Please Wait...</button>
                                      </div>

                                    </div>
                                  </form>

                              </div>
                          </div>
                          <!--/ Debit Card Funding Card Section -->
                      </div>

                      <div *ngIf="selectedMethod === 'auto'" class="payment-card">
                          <!-- Auto Funding Card Section -->
                          <div class="card">
                              <div class="card-body">
                                  <h4 class="card-title">Auto Funding</h4>
                                  <!-- Add relevant information for auto funding here -->
                                  <div class="row" *ngIf="data!.virtual_accounts.length > 0">
                                    <div class="col-md-6 p-1" style="border: 1px solid #ddd; border-radius: 10px;" *ngFor="let item of data!.virtual_accounts">
                                      <h4 class="card-titlee mb-1">{{ item.bankName }}</h4>
                                      <div class="account-number">{{ item.accountNumber }}</div>
                                      <h5 class="mb-1">{{ item.accountName }}</h5>
                                    </div>
                                  </div>

                              </div>
                          </div>
                          <!--/ Auto Funding Card Section -->
                      </div>

                      <div *ngIf="selectedMethod === 'kyc'" class="payment-card">
                          <!-- KYC Verification Section -->
                          <div class="card">
                              <div class="card-body">
                                  <h4 class="card-title">Verify BVN/NIN</h4>
                                  <h5>Link Your BVN/NIN if you have not. Ignore if you have already done it.</h5>
                                  <div class="form-group col-md-12">
                                      <label class="form-label" for="network"><h6>Verification Type</h6></label>
                                      <ng-select (change)="selectKYCMethod($event)">
                                          <ng-option *ngFor="let item of kycMethods" [value]="item">{{item.label}}</ng-option>
                                      </ng-select>
                                  </div>
                                  <div class="col-12" *ngIf="kyc_type.label !==''">
                                    <div class="form-group">
                                      <label for="contact-info-vertical">{{ kyc_type.label }}</label>
                                      <input
                                        type="text"
                                        [(ngModel)]="customer_kyc"
                                        id="contact-info-vertical"
                                        name="customer_kyc"
                                        class="form-control"
                                        placeholder="Enter {{ kyc_type.label }}"
                                      />
                                    </div>
                                  </div>

                                  <div class="col-12">
                                    <button (click)="verifyKYC()" *ngIf="disable_c === false" type="submit" rippleEffect class="btn btn-primary mr-1">Verify Number</button>
                                    <button *ngIf="disable_c === true" type="submit" rippleEffect class="btn btn-outline-secondary mr-1">Verifying...</button>
                                  </div>

                              </div>
                          </div>
                          <!--/ KYC Verification Section -->
                      </div>


                  </div>
                  <!--/ Display Selected Card Section -->
              </div>
          </div>
      </div>
  </div>
</div>